import React from 'react';
import { RichInline, RichNode } from '@/utils';

type Props = {
  nodes: RichNode[];
};

const renderInline = (node: RichInline, key: number) => {
  switch (node.type) {
    case 'text':
      return (
        <span key={key} className="text-tundora">
          {node.content}
        </span>
      );
    case 'underline':
      return (
        <span key={key} className={`block text-primary underline md:inline`}>
          {node.content}
        </span>
      );
    case 'styled':
      return (
        <span
          key={key}
          className="font-workSans text-[16px] font-semibold not-italic leading-[24px] text-tundora"
        >
          {node.content}
        </span>
      );
    case 'mailto':
      return (
        <a key={key} href={`mailto:${node.href}`} className="text-primary underline">
          {node.content}
        </a>
      );
    default:
      return <span key={key} />;
  }
};

const RichText: React.FC<Props> = ({ nodes }) => {
  return (
    <>
      {nodes.map((line, lineIdx) => (
        <div key={lineIdx} className="mb-2 min-h-[1.25rem] leading-[24px]">
          {line.children.map((child, idx) => renderInline(child, idx))}
        </div>
      ))}
    </>
  );
};

export default RichText;
